var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, EButtonType } from 'src/ui/components/button/Button';
import { Modal } from 'src/ui/components/modal/Modal';
import { SelectSection } from 'src/ui/components/Input/SelectSection/SelectSection';
import { TextInput } from 'src/ui/components/Input/TextInput/TextInput';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { COLORS } from 'src/shared/styles/colors';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import styles from './caseReassignmentModal.module.scss';
export var CaseReassignmentModal = function (props) {
    var i18n = props.i18n, teams = props.teams, currentTeam = props.currentTeam, isLoading = props.isLoading, onCancel = props.onCancel, onValidate = props.onValidate;
    var _a = useState(''), searchValue = _a[0], setSearchValue = _a[1];
    var _b = useState(null), currentFocus = _b[0], setCurrentItem = _b[1];
    var _c = useState(true), isValidateButtonDisabled = _c[0], updateStateValidateButton = _c[1];
    var teamsFiltered = teams.filter(function (team) {
        return team.label.toLowerCase().includes(searchValue.toLowerCase()) ||
            team.code.toLowerCase().includes(searchValue.toLowerCase());
    });
    var teamsLabel = teamsFiltered.map(function (team) { return team.label; });
    var modalTitle = getPropsByKeyPath(i18n, 'keyValueMap.caseGlobalView.moActions.showTeamAssignmentModal.popup.title');
    var modalSubtitle = getPropsByKeyPath(i18n, 'modules.teamAssignment.subText');
    var labelCancelButton = getPropsByKeyPath(i18n, 'modules.teamAssignment.cancelButtonLabel');
    var labelValidateButton = getPropsByKeyPath(i18n, 'modules.teamAssignment.submitButtonLabel');
    var searchPlaceholder = getPropsByKeyPath(i18n, 'modules.teamAssignment.searchPlaceholder');
    var noResults = getPropsByKeyPath(i18n, 'modules.teamAssignment.noResults');
    var currentItemLabel = getPropsByKeyPath(i18n, 'modules.teamAssignment.disabledTeam');
    var handleSelectCurrentItem = function (team) {
        if (currentFocus === team) {
            setCurrentItem(null);
            updateStateValidateButton(true);
        }
        else {
            setCurrentItem(team);
            updateStateValidateButton(false);
        }
    };
    var handleConfirmReassign = function () {
        var completedTeam = teamsFiltered.find(function (team) { return team.label === currentFocus; });
        if (completedTeam) {
            onValidate({ agencyCode: completedTeam.code });
        }
        else {
            console.error('Error no team was founded when confirm reassign');
        }
    };
    return (_jsxs(Modal, __assign({ title: modalTitle, subtitle: modalSubtitle, className: styles.input, onClose: onCancel, color: COLORS.PRIMARY['500'] }, { children: [_jsxs("div", __assign({ className: styles.componentsWrapper }, { children: [_jsx(TextInput, { label: searchPlaceholder, value: searchValue, onChange: setSearchValue, rightIcon: E_ICONS.SEARCH }), _jsx("span", { className: styles.separator }), teamsLabel && (_jsx(SelectSection, { className: styles.caseReassignmentSelectTeam, list: teamsLabel, currentValue: currentTeam, currentValueLabel: currentItemLabel, currentFocus: currentFocus, onSelectCurrentItem: handleSelectCurrentItem })), teamsLabel.length === 0 && _jsx("p", __assign({ className: styles.noResultSearchTeams }, { children: noResults }))] })), _jsxs("div", __assign({ className: styles.actionsWrapper }, { children: [_jsx(Button, { type: EButtonType.NEUTRAL, isEdge: true, label: labelCancelButton, onClick: onCancel }), _jsx(Button, { type: EButtonType.NEUTRAL, label: labelValidateButton, onClick: handleConfirmReassign, disabled: isValidateButtonDisabled, isLoading: isLoading })] }))] })));
};
